module.exports = __webpack_public_path__ + "media/images/top-e49b2cb3935fafa86dc7d022f852424c.svg";